import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type CustomPeriodForm from 'modules/attendance/components/TimeTracking/Layout/form'
import type { Status } from 'modules/attendance/store/models/Period'
import Period from 'modules/attendance/store/models/Period'

import CustomPeriodsActions from './../_Actions'

interface Props {
  currentTabState: Status
  selected: Period[]
  onDeselectAll: () => void
  payrollCompensation: boolean
  onCompensate: (employeeIds: number[], timestamp: string) => void
  canConfirm: boolean
  customPeriodForm: CustomPeriodForm
  canSendEmailReminder: boolean
}

const StateHeader = ({
  currentTabState,
  selected,
  onDeselectAll,
  payrollCompensation,
  onCompensate,
  canConfirm,
  customPeriodForm,
  canSendEmailReminder,
}: Props) => {
  const description = (state: Status): string => {
    switch (state) {
      case Period.STATUS.approved:
        return i18n.t('time_tracking.states.approved.description')

      case Period.STATUS.in_progress:
        return i18n.t('time_tracking.states.in_progress.description')

      case Period.STATUS.pending:
        return i18n.t('time_tracking.states.pending.description')

      default:
        return ''
    }
  }

  return (
    <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
      <Text.Normal color="grey800" weight="bold">
        {description(currentTabState)}
      </Text.Normal>
      {canConfirm && (
        <CustomPeriodsActions
          currentTabState={currentTabState}
          selected={selected}
          onDeselectAll={onDeselectAll}
          payrollCompensation={payrollCompensation}
          onCompensate={onCompensate}
          customPeriodForm={customPeriodForm}
          canSendEmailReminder={canSendEmailReminder}
        />
      )}
    </Box>
  )
}

export default observer(StateHeader)
